export const mutations = {
  setCurrentDatasetDetails(state, currentDatasetDetails = null) {
    state.selectedDataSetDetails = currentDatasetDetails;
  },
  setCurrentDatasetFields(state, fields) {
    state.selectedDataSetDetails = { ...state.selectedDataSetDetails, ...fields };
  },
  setDatasetList(state, datasetList) {
    state.dataset = datasetList;
  },
  setIsWidget(state, isWidget) {
    state.isWidget = isWidget;
  },
  setDatasetListLoadingFlag(state, datasetListLoadingFlag = false) {
    state.datasetListLoadingFlag = datasetListLoadingFlag;
  }
};
